import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MeLandingPageFooterComponent } from './landing-page-footer/landing-page-footer.component';
import { MeLandingPageHeaderComponent } from './landing-page-header/landing-page-header.component';
import { MeLandingPageComponent } from './landing-page/landing-page.component';
import { MeFooterComponent } from './me-footer/me-footer.component';
import { MeComponent } from './me.component';
import { AuthUnguard } from '../core/auth.unguard';
import { MeLanguageSwitchComponent } from './language-switch/language-switch.component';

const routes: Routes = [
    {
        path: '', component: MeComponent,
        children: [
            { path: '', component: MeLandingPageComponent},
            { path: 'login',
                loadChildren: () => import('./login/me-login.module').then( m => m.MeLoginModule),
                canActivate: [AuthUnguard]
            },
            { path: 'forgot-password', loadChildren: () => import('./auth/forgot-password/forgot-password.module').then( m => m.MeForgotPasswordModule)},
            { path: 'password-reset/:token', loadChildren: () => import('./auth/password-reset/password-reset.module').then( m => m.MePasswordResetModule)},
            { path: 'register', loadChildren: () => import('./register/me-register.module').then( m => m.MeRegisterModule)},
            { path: 'dashboard',
                loadChildren: () => import('./dashboard/me-dashboard.module').then( m => m.MeDashboardModule),
                // canActivate: [AuthGuard]
            },
            { path: 'banners', loadChildren: () => import('./banners/banners.module').then( m => m.BannersModule)},
            { path: 'profile', loadChildren: () => import('./profile/profile.module').then( m => m.ProfileModule)},
            { path: 'self-evaluation', loadChildren: () => import('./self-report/me-self-report.module').then( m => m.MeSelfReportModule)},
            { path: 'payment', loadChildren: () => import('./payment/me-payment.module').then( m => m.MePaymentModule)},
            { path: 'appointment', loadChildren: () => import('./appointment/appointment.module').then( m => m.MeAppointmentModule)},
            { path: 'login', loadChildren: () => import('./login/me-login.module').then( m => m.MeLoginModule)},
            { path: 'forgot-password', loadChildren: () => import('./auth/forgot-password/forgot-password.module').then( m => m.MeForgotPasswordModule)},
            { path: 'password-reset/:token', loadChildren: () => import('./auth/password-reset/password-reset.module').then( m => m.MePasswordResetModule)},
            { path: 'register', loadChildren: () => import('./register/me-register.module').then( m => m.MeRegisterModule)},
            { path: 'register/jwt', loadChildren: () => import('./register/me-register.module').then( m => m.MeRegisterModule)},
            { path: 'lp/products', loadChildren: () => import('./landing-page/landing-page-product/landing-page-product.module').then( m => m.MeLandingPageProductModule)},
            { path: 'lp/product-labels', loadChildren: () => import('./landing-page/product-labels/product-labels.module').then( m => m.MeProductLabelModule)},
            { path: 'lp/about-us', loadChildren: () => import('./landing-page/about-us/about-us.module').then( m => m.MeAboutUsModule)},
            { path: 'lp/faq', loadChildren: () => import('./landing-page/faq/faq.module').then( m => m.MeFaqModule)},
            { path: 'lp/imprint', loadChildren: () => import('./landing-page/imprint/imprint.module').then( m => m.MeImprintModule)},
            { path: 'lp/quick-test', loadChildren: () => import('./quick-test/quick-test.module').then( m => m.MeQuickTestModule)},
            { path: 'lp/privacy-policy', loadChildren: () => import('./landing-page/policies/policies.module').then( m => m.MeLandingPoliciesModule)},
            { path: 'quick-test', loadChildren: () => import('./quick-test/quick-test.module').then( m => m.MeQuickTestModule)},
            { path: 'policies/:name', loadChildren: () => import('./policies/policies.module').then( m => m.MePoliciesModule)},
            { path: 'article/:name', loadChildren: () => import('./articles/articles.module').then( m => m.MeArticlesModule)},
            { path: 'success/:name', loadChildren: () => import('./success/success-page.module').then( m => m.MeSuccessPageModule)},
            { path: 'diagnosis-prediction/:name', loadChildren: () => import('./diagnosis-prediction/diagnosis-prediction.module').then( m => m.MeDiagnosisPredictionModule)},
            { path: 'dynamic-report', loadChildren: () => import('./dynamic-report/dynamic-report.module').then( m => m.MeDynamicReportModule)},
        ],
    },
    { path: 'lp/header', component: MeLandingPageHeaderComponent},
    { path: 'lp/footer', component: MeLandingPageFooterComponent},
    { path: 'footer', component: MeFooterComponent},
    {
        path: 'en',
        children: [
            {path : '**' , component: MeLanguageSwitchComponent}
        ]
    },
    {
        path: 'de',
        children: [
            {path : '**' , component: MeLanguageSwitchComponent}
        ]
    },
    {
        path: 'fr',
        children: [
            {path : '**' , component: MeLanguageSwitchComponent}
        ]
    },
    {
        path: 'it',
        children: [
            {path : '**' , component: MeLanguageSwitchComponent}
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class MeRoutesModule { }
